import axiosInstance from '@/services/axios'

export default {
  namespaced: true,

  state: {
    items: []
  },

  getters: {
    getProducts(state) {
      return state.items
    },
  },

  actions: {
    fetchProducts({ state, commit }) {
      if (state.items > 0)
        return state.items;

      return axiosInstance.get('products?_sort=name:ASC')
        .then(res => {
          const products = res.data;
          commit('setItems', { resource: 'products', items: products }, { root: true })
          return state.items
        })
        .catch(err => { console.log(err) })
    }
  }
}